module.exports = __webpack_public_path__ + "img/partecipanti_smartform2.3d24e169.png";